export default defineNuxtRouteMiddleware(async (to, from) => {
  const layoutStore = useLayoutStore()
  layoutStore.setLayout('widget')

  navigateTo('/book-now')
})